<section
  class="atw-page blog-details-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">
    <div class="blog-details-loader apply-card" *ngIf="loading">
      <span class="loader-ring"></span>
      <h2>{{ 'atw.blogs.details.loading' | transloco }}</h2>
    </div>

    <div class="blog-details-empty apply-card" *ngIf="!loading && error">
      <div class="empty-icon">
        <img class="img-m" src="assets/as/2.webp" alt="blog not found" />
      </div>

      <h2>{{ error }}</h2>

      <button type="button" class="secondary-action" (click)="goBackToBlogs()">
        {{ 'atw.blogs.details.backToBlogs' | transloco }}
      </button>
    </div>

    <article class="blog-details" *ngIf="!loading && !error && blog">
      <button type="button" class="secondary-action back-action" (click)="goBackToBlogs()">
        {{ 'atw.blogs.details.backToBlogs' | transloco }}
      </button>

      <header class="blog-details-hero">
        <div class="blog-details-hero-content">
          <div class="blog-category-pill">
            {{ blog.categoryLabel }}
          </div>

          <h1>{{ blog.title }}</h1>

          <p>{{ blog.excerpt }}</p>

          <div class="blog-meta" *ngIf="blog.dateLabel || blog.readTimeLabel">
            <span *ngIf="blog.dateLabel">{{ blog.dateLabel }}</span>
            <span *ngIf="blog.dateLabel && blog.readTimeLabel">•</span>
            <span *ngIf="blog.readTimeLabel">{{ blog.readTimeLabel }}</span>
          </div>
        </div>

        <div class="blog-details-media">
          <img
            [src]="blog.image"
            [alt]="blog.title"
            (error)="onImageError($event)"
          />
        </div>
      </header>

      <div class="blog-details-layout">
        <main class="blog-article-card apply-card">
          <div class="blog-article-content api-content" *ngIf="blog.contentHtml; else staticContent">
            <div [innerHTML]="blog.contentHtml"></div>
          </div>

          <ng-template #staticContent>
            <div class="blog-article-content">
              <p *ngFor="let paragraph of blog.paragraphs">{{ paragraph }}</p>
            </div>
          </ng-template>
        </main>

        <aside class="blog-side-card apply-card">
          <span>{{ 'atw.blogs.details.inThisArticle' | transloco }}</span>

          <h3>{{ blog.title }}</h3>

          <div class="keyword-list blog-tags" *ngIf="blog.tags.length">
            <span *ngFor="let tag of blog.tags">{{ tag }}</span>
          </div>

          <a class="primary-action" routerLink="/smartapply">
            {{ 'atw.blogs.cta.btn' | transloco }}
          </a>
        </aside>
      </div>
    </article>
  </div>
</section>
